module.exports = __webpack_public_path__ + "img/Colombia.66134ff5.png";